export default "__VITE_ASSET__BFh3foII__"